import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React, { Component } from 'react';
import TableRow from '../../TableRow/TableRow';
class TableResponsiveChildRow extends Component {
    renderChildren() {
        const nextUUID = this.nextUUID();
        const newChildren = React.Children.toArray(this.props.children);
        return newChildren.map((child)=>{
            if (child.type) {
                if (child.type.displayName === TableRow.displayName) {
                    const nestedChidren = child.props.children;
                    return nestedChidren.map((innerChild)=>/*#__PURE__*/ React.cloneElement(innerChild, {
                            key: nextUUID()
                        }));
                }
                return /*#__PURE__*/ React.cloneElement(child, {
                    key: nextUUID()
                });
            }
            return undefined;
        });
    }
    nextUUID(start = 0) {
        let base = start;
        return ()=>base++;
    }
    render() {
        const open = this.props.open;
        return /*#__PURE__*/ React.createElement("tr", {
            className: cx('Table-row', 'Table-row--typeChild', {
                'Table-row--opened': open
            })
        }, this.renderChildren());
    }
}
TableResponsiveChildRow.propTypes = {
    /**
	 * Children will be rendered within the `TableResponsiveRow`.
	 */ children: PropTypes.node,
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * If the row would be show or hidden.
	 */ open: PropTypes.bool
};
TableResponsiveChildRow.displayName = 'TableResponsiveChildRow';
export default TableResponsiveChildRow;
